export const news = {
  headerTitle: "NEWS",
  purchaseFirstTitle: "初回購入限定！",
  purchaseFirstDesc: "ポイント増量✨",
  purchaseSecondTitle: "2回目購入限定！",
  purchaseSecondDesc: "30%お得🉐",
  purchaseThirdTitle: "3回目購入限定！",
  purchaseThirdDesc: "800ptお得🉐",
  purchaseFourthTitle: "4回目購入限定！",
  purchaseFourthDesc: "1000pt増量✨",
  purchaseFifthTitle: "5回目購入限定！",
  purchaseFifthDesc: "ポイント増量✨",
  webPaymentTitle: "ApplePayやクレジットカードでの決済が可能に！",
  webPaymentDesc: "購入画面はこちら🌟",
  dailyBonusTitle: "ポイント購入で毎日がお得に！",
  dailyBonusDesc: "デイリーボーナスが毎日2倍！",
  lovenseTitle: "遠隔操作で",
  lovenseDesc: "ビデオ通話を楽しもう♪",
  spuPointBackTitle: "ポイントバックキャンペーン実施中！",
  spuPointBackDesc: "毎週最大3000ptポイントバック！",
  campaignEimiTitle: "深田えいみ降臨コラボイベント開催！",
  campaignEimiDesc: "詳しくはこちら🎉",
  campaignEimiPointBackTitle: "超ポイント還元祭開催！",
  campaignEimiPointBackDesc: "消費ポイントの10%還元🎉",
  campaignEimiPointRankingTitle: "",
  campaignEimiPointRankingDesc:
    "ポイント消費上位5位までに豪華賞品プレゼント！！\n　詳しくはこちら🏆️",
  campaignEimiPresentTitle: "深田えいみの豪華景品！",
  campaignEimiPresentDesc: "GETのチャンス🎁",
} as const;
